import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/common/SEO';
import { useHydrated } from '../hooks/useHydrated';
import { useTranslation } from '../hooks/useTranslation';
import './ImportantDates.css';

const muhurthamData = [
  {
    month: 'January',
    dates: [
      { date: 'Jan 28', day: 'Wednesday', phase: 'Valarpirai', category: 'Wedding' },
    ],
  },
  {
    month: 'February',
    dates: [
      { date: 'Feb 6', day: 'Friday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Feb 8', day: 'Sunday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Feb 13', day: 'Friday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Feb 15', day: 'Sunday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Feb 16', day: 'Monday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Feb 19', day: 'Thursday', phase: 'Valarpirai', category: 'Griha Pravesh' },
      { date: 'Feb 20', day: 'Friday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'Feb 26', day: 'Thursday', phase: 'Valarpirai', category: 'Griha Pravesh' },
    ],
  },
  {
    month: 'March',
    dates: [
      { date: 'Mar 5', day: 'Thursday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Mar 6', day: 'Friday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Mar 8', day: 'Sunday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Mar 15', day: 'Sunday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Mar 16', day: 'Monday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Mar 25', day: 'Wednesday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'Mar 25', day: 'Wednesday', phase: 'Valarpirai', category: 'Griha Pravesh' },
    ],
  },
  {
    month: 'April',
    dates: [
      { date: 'Apr 1', day: 'Wednesday', phase: 'Valarpirai', category: 'Griha Pravesh' },
      { date: 'Apr 6', day: 'Monday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Apr 12', day: 'Sunday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Apr 13', day: 'Monday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Apr 16', day: 'Thursday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Apr 19', day: 'Sunday', phase: 'Valarpirai', category: 'Akshaya Tritiya' },
      { date: 'Apr 20', day: 'Monday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'Apr 20', day: 'Monday', phase: 'Valarpirai', category: 'Griha Pravesh' },
      { date: 'Apr 21', day: 'Tuesday', phase: 'Valarpirai', category: 'Griha Pravesh' },
      { date: 'Apr 23', day: 'Thursday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'Apr 30', day: 'Thursday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'Apr 30', day: 'Thursday', phase: 'Valarpirai', category: 'Griha Pravesh' },
    ],
  },
  {
    month: 'May',
    dates: [
      { date: 'May 8', day: 'Friday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'May 13', day: 'Wednesday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'May 14', day: 'Thursday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'May 18', day: 'Monday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'May 18', day: 'Monday', phase: 'Valarpirai', category: 'Griha Pravesh' },
      { date: 'May 25', day: 'Monday', phase: 'Valarpirai', category: 'Griha Pravesh' },
      { date: 'May 27', day: 'Wednesday', phase: 'Valarpirai', category: 'Griha Pravesh' },
      { date: 'May 28', day: 'Thursday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'May 29', day: 'Friday', phase: 'Valarpirai', category: 'Wedding' },
    ],
  },
  {
    month: 'June',
    dates: [
      { date: 'Jun 4', day: 'Thursday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Jun 7', day: 'Sunday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Jun 17', day: 'Wednesday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'Jun 18', day: 'Thursday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'Jun 24', day: 'Wednesday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'Jun 24', day: 'Wednesday', phase: 'Valarpirai', category: 'Griha Pravesh' },
      { date: 'Jun 25', day: 'Thursday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'Jun 26', day: 'Friday', phase: 'Valarpirai', category: 'Griha Pravesh' },
    ],
  },
  {
    month: 'July',
    dates: [
      { date: 'Jul 2', day: 'Thursday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Jul 5', day: 'Sunday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Jul 12', day: 'Sunday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Jul 20', day: 'Monday', phase: 'Valarpirai', category: 'Griha Pravesh' },
      { date: 'Jul 24', day: 'Friday', phase: 'Valarpirai', category: 'Griha Pravesh' },
      { date: 'Jul 29', day: 'Wednesday', phase: 'Valarpirai', category: 'Griha Pravesh' },
    ],
  },
  {
    month: 'August',
    dates: [
      { date: 'Aug 15', day: 'Saturday', phase: 'Valarpirai', category: 'Griha Pravesh' },
      { date: 'Aug 17', day: 'Monday', phase: 'Valarpirai', category: 'Griha Pravesh' },
      { date: 'Aug 23', day: 'Sunday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'Aug 30', day: 'Sunday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Aug 31', day: 'Monday', phase: 'Theipirai', category: 'Wedding' },
    ],
  },
  {
    month: 'September',
    dates: [
      { date: 'Sep 7', day: 'Monday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Sep 13', day: 'Sunday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'Sep 14', day: 'Monday', phase: 'Valarpirai', category: 'Griha Pravesh' },
      { date: 'Sep 17', day: 'Thursday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'Sep 17', day: 'Thursday', phase: 'Valarpirai', category: 'Griha Pravesh' },
      { date: 'Sep 21', day: 'Monday', phase: 'Valarpirai', category: 'Griha Pravesh' },
    ],
  },
  {
    month: 'October',
    dates: [
      { date: 'Oct 15', day: 'Thursday', phase: 'Valarpirai', category: 'Griha Pravesh' },
      { date: 'Oct 23', day: 'Friday', phase: 'Valarpirai', category: 'Griha Pravesh' },
      { date: 'Oct 25', day: 'Sunday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'Oct 30', day: 'Friday', phase: 'Theipirai', category: 'Wedding' },
    ],
  },
  {
    month: 'November',
    dates: [
      { date: 'Nov 1', day: 'Sunday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Nov 11', day: 'Wednesday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'Nov 11', day: 'Wednesday', phase: 'Valarpirai', category: 'Griha Pravesh' },
      { date: 'Nov 13', day: 'Friday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'Nov 15', day: 'Sunday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'Nov 16', day: 'Monday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'Nov 20', day: 'Friday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'Nov 20', day: 'Friday', phase: 'Valarpirai', category: 'Griha Pravesh' },
      { date: 'Nov 29', day: 'Sunday', phase: 'Theipirai', category: 'Wedding' },
    ],
  },
  {
    month: 'December',
    dates: [
      { date: 'Dec 4', day: 'Friday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Dec 6', day: 'Sunday', phase: 'Theipirai', category: 'Wedding' },
      { date: 'Dec 10', day: 'Thursday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'Dec 12', day: 'Saturday', phase: 'Valarpirai', category: 'Griha Pravesh' },
      { date: 'Dec 13', day: 'Sunday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'Dec 14', day: 'Monday', phase: 'Valarpirai', category: 'Wedding' },
      { date: 'Dec 23', day: 'Wednesday', phase: 'Valarpirai', category: 'Griha Pravesh' },
    ],
  },
];

const categoryColors = {
  Wedding: '#e65100',
  'Griha Pravesh': '#1565c0',
  'Akshaya Tritiya': '#ff6f00',
};

const phaseColors = {
  Valarpirai: '#2e7d32',
  Theipirai: '#6a1b9a',
};

const categoryLabels = ['All', 'Wedding', 'Griha Pravesh'];
const phaseLabels = ['All Phases', 'Valarpirai', 'Theipirai'];

const ImportantDates = () => {
  const currentYear = new Date().getFullYear();
  const [categoryFilter, setCategoryFilter] = useState('All');
  const [phaseFilter, setPhaseFilter] = useState('All Phases');
  const [searchTerm, setSearchTerm] = useState('');
  const hydrated = useHydrated();
  const { t, lang } = useTranslation();

  const ta = lang === 'ta';

  const monthTamil = {
    January: 'ஜனவரி', February: 'பிப்ரவரி', March: 'மார்ச்', April: 'ஏப்ரல்',
    May: 'மே', June: 'ஜூன்', July: 'ஜூலை', August: 'ஆகஸ்ட்',
    September: 'செப்டம்பர்', October: 'அக்டோபர்', November: 'நவம்பர்', December: 'டிசம்பர்',
  };

  const dayTamil = {
    Sunday: 'ஞாயிறு', Monday: 'திங்கள்', Tuesday: 'செவ்வாய்', Wednesday: 'புதன்',
    Thursday: 'வியாழன்', Friday: 'வெள்ளி', Saturday: 'சனி',
  };

  const categoryTamil = {
    All: ta ? 'அனைத்தும்' : 'All',
    Wedding: ta ? 'திருமணம்' : 'Wedding',
    'Griha Pravesh': ta ? 'கிரகப் பிரவேசம்' : 'Griha Pravesh',
    'Akshaya Tritiya': ta ? 'அக்ஷய திருதியை' : 'Akshaya Tritiya',
  };

  const phaseTamil = {
    'All Phases': ta ? 'அனைத்து நிலைகள்' : 'All Phases',
    Valarpirai: ta ? 'வளர்பிறை' : 'Valarpirai',
    Theipirai: ta ? 'தேய்பிறை' : 'Theipirai',
  };

  const filteredData = muhurthamData
    .map((monthData) => ({
      ...monthData,
      dates: monthData.dates.filter((d) => {
        const matchesCategory = categoryFilter === 'All' || d.category === categoryFilter;
        const matchesPhase = phaseFilter === 'All Phases' || d.phase === phaseFilter;
        const matchesSearch =
          d.date.toLowerCase().includes(searchTerm.toLowerCase()) ||
          d.day.toLowerCase().includes(searchTerm.toLowerCase()) ||
          d.category.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesCategory && matchesPhase && matchesSearch;
      }),
    }))
    .filter((monthData) => monthData.dates.length > 0);

  const totalDates = filteredData.reduce((sum, m) => sum + m.dates.length, 0);

  const weddingCount = muhurthamData.reduce(
    (sum, m) => sum + m.dates.filter((d) => d.category === 'Wedding').length,
    0
  );
  const grihaPraveshCount = muhurthamData.reduce(
    (sum, m) => sum + m.dates.filter((d) => d.category === 'Griha Pravesh').length,
    0
  );

  return (
    <div className="important-dates-page">
      <SEO
        title={`Tamil Muhurtham Dates ${currentYear} - Auspicious Wedding & Griha Pravesh Dates`}
        description={`Complete list of Tamil Muhurtham dates for ${currentYear}. Find auspicious dates for weddings, griha pravesh (housewarming), and other ceremonies with Valarpirai and Theipirai details.`}
        keywords={`tamil muhurtham dates ${currentYear}, wedding muhurtham ${currentYear}, griha pravesh dates ${currentYear}, shubh muhurat ${currentYear}, tamil calendar auspicious dates`}
        canonicalPath="/important-dates"
        jsonLd={[{"@context":"https://schema.org","@type":"FAQPage","mainEntity":[{"@type":"Question","name":"What is the importance of Muhurtham in Hindu ceremonies?","acceptedAnswer":{"@type":"Answer","text":"Muhurtham (auspicious time) is based on the belief that the planetary positions at the start of an important event influence its entire course. A good muhurtham ensures favorable cosmic energy supports the event — whether a wedding, business launch, travel, or housewarming. Vedic astrology uses precise astronomical calculations to identify these windows of maximum cosmic support."}},{"@type":"Question","name":"How long is a Muhurtham period?","acceptedAnswer":{"@type":"Answer","text":"A Muhurtham (muhurta) is traditionally 48 minutes long — 1/30th of a day. However, in practice, an auspicious Muhurtham window for ceremonies is determined by the overlap of favorable Tithi, Nakshatra, Yoga, and Lagna — which may span anywhere from 30 minutes to 3 hours depending on the day."}},{"@type":"Question","name":"Can a wedding happen during Rahu Kalam?","acceptedAnswer":{"@type":"Answer","text":"Rahu Kalam is generally avoided for weddings and other important ceremonies. However, Abhijit Muhurta (midday period) is so powerful that it overrides most inauspicious timings. A qualified astrologer can identify exceptions based on the overall Panchang strength of the day."}},{"@type":"Question","name":"Is Jathagam Porutham (horoscope matching) necessary before fixing Muhurtham?","acceptedAnswer":{"@type":"Answer","text":"Yes, traditionally Jathagam Porutham (horoscope compatibility matching) is done first to ensure the couple is compatible. Once the match is confirmed, an auspicious Muhurtham is selected. The muhurtham should be checked against both the bride's and groom's individual birth charts to ensure it is favorable for both — avoiding their personal Chandrashtama days and unfavorable Dasha periods."}}]}]}
      />

      <div className="container">
        <motion.div
          className="page-header"
          initial={hydrated ? { opacity: 0, y: -20 } : false}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1>
            {ta ? 'தமிழ் முகூர்த்தம்' : 'Tamil Muhurtham'} <span className="gradient-text">{ta ? `நாட்கள் ${currentYear}` : `Dates ${currentYear}`}</span>
          </h1>
          <p>{ta ? 'திருமணம், கிரகப் பிரவேசம் மற்றும் முக்கிய சடங்குகளுக்கான சுப நாட்கள்' : 'Auspicious dates for weddings, griha pravesh, and important ceremonies'}</p>
        </motion.div>

        {/* Stats Cards */}
        <motion.div
          className="muhurtham-stats"
          initial={hydrated ? { opacity: 0, y: 10 } : false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15 }}
        >
          <div className="stat-card">
            <span className="stat-icon">&#128141;</span>
            <div className="stat-info">
              <span className="stat-number">{weddingCount}</span>
              <span className="stat-label">{ta ? 'திருமண நாட்கள்' : 'Wedding Dates'}</span>
            </div>
          </div>
          <div className="stat-card">
            <span className="stat-icon">&#127968;</span>
            <div className="stat-info">
              <span className="stat-number">{grihaPraveshCount}</span>
              <span className="stat-label">{ta ? 'கிரகப் பிரவேசம்' : 'Griha Pravesh'}</span>
            </div>
          </div>
          <div className="stat-card">
            <span className="stat-icon">&#127775;</span>
            <div className="stat-info">
              <span className="stat-number">12</span>
              <span className="stat-label">{ta ? 'மாதங்கள்' : 'Months Covered'}</span>
            </div>
          </div>
        </motion.div>

        {/* Info Banner */}
        <motion.div
          className="muhurtham-info-banner"
          initial={hydrated ? { opacity: 0, scale: 0.95 } : false}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2 }}
        >
          <span className="info-banner-icon">&#9733;</span>
          <div>
            {ta ? (
              <><strong>வளர்பிறை</strong> நாட்கள் புதிய தொடக்கங்களுக்கு மிகவும் சுபமானவை. <strong>தேய்பிறை</strong> நாட்களும் நட்சத்திரம் மற்றும் திதிக்கு ஏற்ப ஏற்றுக்கொள்ளத்தக்கவை. தனிப்பட்ட ஜாதக பொருத்தத்திற்கு எப்போதும் ஜோதிடரை அணுகவும்.</>
            ) : (
              <><strong>Valarpirai (Waxing Moon)</strong> dates are most auspicious for new beginnings.{' '}<strong>Theipirai (Waning Moon)</strong> dates are also acceptable depending on nakshatra and thithi. Always consult an astrologer for personal horoscope compatibility.</>
            )}
          </div>
        </motion.div>

        {/* Filters */}
        <motion.div
          className="muhurtham-controls"
          initial={hydrated ? { opacity: 0, y: 10 } : false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <div className="muhurtham-search">
            <input
              type="text"
              placeholder={ta ? 'தேதி, நாள் அல்லது வகை மூலம் தேடுங்கள்...' : 'Search by date, day, or category...'}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="muhurtham-search-input"
            />
          </div>
          <div className="muhurtham-filters-row">
            <div className="filter-group">
              <span className="filter-group-label">{ta ? 'வகை:' : 'Category:'}</span>
              <div className="muhurtham-filter-tags">
                {categoryLabels.map((cat) => (
                  <button
                    key={cat}
                    className={`filter-tag ${categoryFilter === cat ? 'active' : ''}`}
                    onClick={() => setCategoryFilter(cat)}
                    style={
                      categoryFilter === cat && cat !== 'All'
                        ? { background: categoryColors[cat], borderColor: categoryColors[cat], color: '#fff' }
                        : {}
                    }
                  >
                    {categoryTamil[cat] || cat}
                  </button>
                ))}
              </div>
            </div>
            <div className="filter-group">
              <span className="filter-group-label">{ta ? 'சந்திர நிலை:' : 'Moon Phase:'}</span>
              <div className="muhurtham-filter-tags">
                {phaseLabels.map((phase) => (
                  <button
                    key={phase}
                    className={`filter-tag ${phaseFilter === phase ? 'active' : ''}`}
                    onClick={() => setPhaseFilter(phase)}
                    style={
                      phaseFilter === phase && phase !== 'All Phases'
                        ? { background: phaseColors[phase], borderColor: phaseColors[phase], color: '#fff' }
                        : {}
                    }
                  >
                    {phaseTamil[phase] || phase}
                  </button>
                ))}
              </div>
            </div>
          </div>
          <div className="muhurtham-count">
            {ta ? `${totalDates} நாட்கள் காட்டுகிறது` : `Showing ${totalDates} date${totalDates !== 1 ? 's' : ''}`}
          </div>
        </motion.div>

        {/* Month Cards */}
        <div className="muhurtham-grid">
          {filteredData.map((monthData, idx) => (
            <motion.div
              key={monthData.month}
              className="muhurtham-month-card"
              initial={hydrated ? { opacity: 0, y: 20 } : false}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.08 * idx }}
            >
              <div className="muhurtham-month-header">
                <h2>{ta ? monthTamil[monthData.month] : monthData.month}</h2>
                <span className="muhurtham-month-count">{monthData.dates.length} {ta ? 'நாட்கள்' : 'dates'}</span>
              </div>
              <div className="muhurtham-month-dates">
                <div className="muhurtham-table-header">
                  <span className="col-date">{ta ? 'தேதி' : 'Date'}</span>
                  <span className="col-day">{ta ? 'நாள்' : 'Day'}</span>
                  <span className="col-phase">{ta ? 'சந்திர நிலை' : 'Moon Phase'}</span>
                  <span className="col-category">{ta ? 'வகை' : 'For'}</span>
                </div>
                {monthData.dates.map((item, dIdx) => (
                  <div key={dIdx} className="muhurtham-row">
                    <span className="col-date">
                      <span className="date-number">{item.date.split(' ')[1]}</span>
                    </span>
                    <span className="col-day">{ta ? dayTamil[item.day] : item.day}</span>
                    <span className="col-phase">
                      <span
                        className="phase-badge"
                        style={{ background: phaseColors[item.phase] || '#888' }}
                      >
                        {phaseTamil[item.phase] || item.phase}
                      </span>
                    </span>
                    <span className="col-category">
                      <span
                        className="category-badge"
                        style={{ background: categoryColors[item.category] || '#888' }}
                      >
                        {categoryTamil[item.category] || item.category}
                      </span>
                    </span>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>

        {filteredData.length === 0 && (
          <div className="no-results">
            <p>{ta ? 'உங்கள் வடிகட்டிகளுக்கு பொருந்தும் முகூர்த்த நாட்கள் இல்லை.' : 'No muhurtham dates found matching your filters.'}</p>
          </div>
        )}

        {/* Best Months Section */}
        <motion.div
          className="best-months-section"
          initial={hydrated ? { opacity: 0, y: 20 } : false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
        >
          <h2>{ta ? `${currentYear}-ல் திருமணத்திற்கு சிறந்த மாதங்கள்` : `Best Months for Weddings in ${currentYear}`}</h2>
          <div className="best-months-grid">
            <div className="best-month-card best">
              <div className="best-month-icon">&#128150;</div>
              <h3>{ta ? 'நவம்பர்' : 'November'}</h3>
              <p>{ta ? '7 திருமண நாட்கள் - அதிக விருப்பங்கள்' : '7 wedding dates - Most options'}</p>
            </div>
            <div className="best-month-card best">
              <div className="best-month-icon">&#128150;</div>
              <h3>{ta ? 'ஏப்ரல்' : 'April'}</h3>
              <p>{ta ? '7 திருமண நாட்கள் அக்ஷய திருதியை உட்பட' : '7 wedding dates including Akshaya Tritiya'}</p>
            </div>
            <div className="best-month-card good">
              <div className="best-month-icon">&#128153;</div>
              <h3>{ta ? 'பிப்ரவரி - ஜூன்' : 'February - June'}</h3>
              <p>{ta ? 'ஒவ்வொரு மாதமும் 6 திருமண நாட்கள்' : '6 wedding dates each month'}</p>
            </div>
            <div className="best-month-card caution">
              <div className="best-month-icon">&#128312;</div>
              <h3>{ta ? 'தவிர்க்கவும்: ஆடி, புரட்டாசி, மார்கழி' : 'Avoid: Aadi, Purattasi, Margazhi'}</h3>
              <p>{ta ? 'திருமணத்திற்கு பாரம்பரியமாக விரும்பப்படுவதில்லை' : 'Traditionally not preferred for weddings'}</p>
            </div>
          </div>
        </motion.div>

        {/* Notes Section */}
        <motion.div
          className="muhurtham-notes"
          initial={hydrated ? { opacity: 0, y: 20 } : false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
        >
          <h2>{ta ? 'முக்கிய குறிப்புகள்' : 'Important Notes'}</h2>
          <ul>
            <li>
              {ta ? <><strong>வளர்பிறை</strong> - திருமணம் மற்றும் புதிய தொடக்கங்களுக்கு மிகவும் சுபமானது</> : <><strong>Valarpirai (Waxing Moon)</strong> - Considered more auspicious for weddings and new beginnings</>}
            </li>
            <li>
              {ta ? <><strong>தேய்பிறை</strong> - நட்சத்திரம் மற்றும் திதி சீரமைப்பைப் பொறுத்து ஏற்றுக்கொள்ளத்தக்கது</> : <><strong>Theipirai (Waning Moon)</strong> - Acceptable depending on nakshatra and thithi alignment</>}
            </li>
            <li>{ta ? 'முகூர்த்த நாட்களிலும் ராகு காலம், எமகண்டம், குளிகை காலங்களை தவிர்க்கவும்' : 'Avoid Rahu Kalam, Yamagandam, and Kuligai periods even on muhurtham dates'}</li>
            <li>{ta ? 'திருமணத்திற்கு தனிப்பட்ட ஜாதக பொருத்தம் அவசியம்' : 'Personal Jathagam Porutham (horoscope matching) is essential for weddings'}</li>
            <li>{ta ? 'துல்லியமான முகூர்த்த லக்னத்திற்கு தகுதியான ஜோதிடரை அணுகவும்' : 'Consult a qualified astrologer for the precise muhurtham lagnam (auspicious time window)'}</li>
          </ul>
        </motion.div>

        {/* Bottom SEO Content */}
        <div className="page-bottom-content">
          <h2>Tamil Muhurtham Dates - Auspicious Wedding & Griha Pravesh Dates</h2>
          <p>Find the most auspicious Tamil Muhurtham dates for weddings, griha pravesh (housewarming), and important ceremonies. Muhurtham dates are carefully calculated based on Panchang elements including Tithi, Nakshatra, Yoga, and planetary positions to ensure the most favorable cosmic alignment for life's important events.</p>
          <p>In Tamil tradition, wedding muhurthams are selected during Valarpirai (waxing moon) phase for maximum auspiciousness. Months like Aadi, Purattasi, and Margazhi are traditionally avoided for weddings. Our calendar shows all available muhurtham dates categorized by moon phase, ceremony type, and month — helping you plan your wedding or griha pravesh with confidence in Vedic astrological principles.</p>

          <h3>How Muhurtham Dates Are Calculated in Tamil Astrology</h3>
          <p>A Muhurtham is an auspicious time window determined by the confluence of favorable Panchang elements. For a wedding Muhurtham, astrologers evaluate the Tithi (Shashti, Saptami, Dashami, Dwadashi, and Trayodashi are preferred), Nakshatra (Rohini, Mrigashira, Magha, Uttara Phalguni, Hasta, Swati, Anuradha, Uttarashada, Uttara Bhadrapada are auspicious), Yoga (avoiding Vishkambha, Vyatipata, and Parigha), and the Lagna (rising sign at the time). The absence of Rahu Kalam and the position of Jupiter and Venus (both must not be in retrograde or combust) are also critical factors.</p>

          <h3>Auspicious Tamil Months for Weddings</h3>
          <p><strong>Best months for Tamil weddings:</strong> Panguni (March-April), Vaikasi (May-June), and Karthigai (November-December) are traditionally the most auspicious months for Tamil weddings. Chittirai (April-May) is preferred for many communities. These months have favorable planetary positions and avoid inauspicious periods.</p>
          <p><strong>Months to avoid:</strong> Aadi (July-August) is typically avoided as it falls during Ashada masa, considered inauspicious for new beginnings. Purattasi (September-October) is a month of fasting and worship and is generally avoided for celebrations. Margazhi (December-January) is a sacred month of intense devotion avoided for weddings in many traditions.</p>

          <h3>Griha Pravesh (Housewarming) Muhurtham</h3>
          <p>Griha Pravesh is the ceremony performed when entering a new home. The most important factors for this muhurtham are: the Sun should be in Uttarayan (northern solstice, January to July); avoid Ashada, Bhadrapada, Paush, and Adhik Maas months; choose an auspicious Nakshatra (Rohini, Hasta, Uttara Phalguni, Uttarashada, Uttara Bhadrapada, Dhanishta, Shravana are best); and the Lagna lord should be strong. The new home should be entered during Abhijit Muhurta whenever possible for maximum prosperity.</p>

          <h3>Frequently Asked Questions About Muhurtham</h3>
          <div className="faq-seo">
            <div className="faq-seo-item">
              <h4>What is the importance of Muhurtham in Hindu ceremonies?</h4>
              <p>Muhurtham (auspicious time) is based on the belief that the planetary positions at the start of an important event influence its entire course. A good muhurtham ensures favorable cosmic energy supports the event — whether a wedding, business launch, travel, or housewarming. Vedic astrology uses precise astronomical calculations to identify these windows of maximum cosmic support.</p>
            </div>
            <div className="faq-seo-item">
              <h4>How long is a Muhurtham period?</h4>
              <p>A Muhurtham (muhurta) is traditionally 48 minutes long — 1/30th of a day. However, in practice, an auspicious Muhurtham window for ceremonies is determined by the overlap of favorable Tithi, Nakshatra, Yoga, and Lagna — which may span anywhere from 30 minutes to 3 hours depending on the day.</p>
            </div>
            <div className="faq-seo-item">
              <h4>Can a wedding happen during Rahu Kalam?</h4>
              <p>Rahu Kalam is generally avoided for weddings and other important ceremonies. However, Abhijit Muhurta (midday period) is so powerful that it overrides most inauspicious timings. A qualified astrologer can identify exceptions based on the overall Panchang strength of the day.</p>
            </div>
            <div className="faq-seo-item">
              <h4>Is Jathagam Porutham (horoscope matching) necessary before fixing Muhurtham?</h4>
              <p>Yes, traditionally Jathagam Porutham (horoscope compatibility matching) is done first to ensure the couple is compatible. Once the match is confirmed, an auspicious Muhurtham is selected. The muhurtham should be checked against both the bride's and groom's individual birth charts to ensure it is favorable for both — avoiding their personal Chandrashtama days and unfavorable Dasha periods.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportantDates;
